(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-showcase"] && !Shopify.designMode) return;
  try {
    
  /* Scale iframes to fit inside the MacBook screen */
  function scaleMacbookIframes() {
    document.querySelectorAll('.macbook__iframe-container').forEach(function(container) {
      var screen = container.closest('.macbook__screen');
      if (!screen) return;
      var scale = screen.offsetWidth / 1440;
      container.style.transform = 'scale(' + scale + ')';
      container.style.height = (screen.offsetHeight / scale) + 'px';
    });
  }

  /* Run on load */
  scaleMacbookIframes();

  /* Run on resize with debounce */
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(scaleMacbookIframes, 100);
  });

  /* Re-run after fonts load (can shift layout) */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scaleMacbookIframes);
  }

  } catch(e) { console.error(e); }
})();
})();
